import { savingsOverview } from './overview-config/CZ';
import { savingsSettingsDetails } from './settings-config/CZ';

export const savings = {
    settingsDetails: savingsSettingsDetails,
    overview: savingsOverview,
};
